import { render, staticRenderFns } from "./OnboardingChoice.vue?vue&type=template&id=bad4c2ba&scoped=true&"
import script from "./OnboardingChoice.vue?vue&type=script&lang=ts&"
export * from "./OnboardingChoice.vue?vue&type=script&lang=ts&"
import style0 from "./OnboardingChoice.vue?vue&type=style&index=0&id=bad4c2ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4c2ba",
  null
  
)

export default component.exports